export default () => {
  return [
    { id: 1, text: 'Male' },
    { id: 2, text: 'Female' },
    { id: 3, text: 'Non-Binary' }
  ]
}
